/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：748__part-0
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_35 from /* 35 */"../35"
import * as /* [auto-meaningful-name] */Module_40 from /* 40 */"../40/index"
import * as /* [auto-meaningful-name] */Module_19 from /* 19 */"../19"
import /* 0 */"react"
import * as /* [auto-meaningful-name] */Module_1544 from /* 1544 */"./1544/index"
import * as /* [auto-meaningful-name] */Classnames from /* 8 */"classnames"
import /* [auto-meaningful-name] */Classnames1 from /* 8 */"classnames"
import * as /* [auto-meaningful-name] */Module_1031 from /* 1031 */"./1031"
var f = {
  adjustX: 1,
  adjustY: 1
}
var d = {
  adjustX: 0,
  adjustY: 0
}
var h = [0, 0]
function p(e) {
  return "boolean" === typeof e ? e ? f : d : Module_19.a(Module_19.a({}, d), e)
}
export { h }
export { p }
